/**
 * Image slice (SCRUM-1953, RTK bundle 4) — the former switch reducer
 * ImageReducer.js as createSlice. Behaviour-preserving: every case answers the
 * same legacy action type string (ImageTypes.js) that ImageActions.js and the
 * upload hooks already dispatch, and returns the same state. The actions module
 * is unchanged, so no importer changes.
 * Characterised by tests/integration/reducers/catalogueReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  QUOTE_RECEIVED,
  CLEAR_URL,
  QUOTES_RECEIVED,
  CLEAR_URLS,
  CREATE_FOLDER,
  GET_FOLDERS,
  GET_PICTURES,
  CLEAR_FOLDER,
  SET_PATH,
} from "./ImageTypes";

type ImageState = {
  url: string;
  folders: any[];
  pictures: any[];
  folder: any;
  uploadedImages: any[];
  path: string;
};

const initialState: ImageState = {
  url: "",
  folders: [],
  pictures: [],
  folder: {},
  uploadedImages: [],
  path: "",
};

const imageSlice = createSlice({
  name: "images",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(QUOTE_RECEIVED, (state, action: PayloadAction<string, typeof QUOTE_RECEIVED>) => ({ ...state, url: action.payload }))
      .addCase(CLEAR_URL, (state) => ({ ...state, url: "" }))
      .addCase(QUOTES_RECEIVED, (state, action: PayloadAction<ImageState["uploadedImages"][number], typeof QUOTES_RECEIVED>) => ({
        ...state,
        uploadedImages: [...state.uploadedImages, action.payload],
      }))
      .addCase(CLEAR_URLS, (state) => ({ ...state, uploadedImages: [] }))
      .addCase(CREATE_FOLDER, (state, action: PayloadAction<ImageState["folder"], typeof CREATE_FOLDER>) => ({ ...state, folder: action.payload }))
      .addCase(CLEAR_FOLDER, (state) => ({ ...state, folder: {} }))
      .addCase(GET_FOLDERS, (state, action: PayloadAction<ImageState["folders"], typeof GET_FOLDERS>) => ({ ...state, folders: action.payload }))
      .addCase(GET_PICTURES, (state, action: PayloadAction<ImageState["pictures"], typeof GET_PICTURES>) => ({ ...state, pictures: action.payload }))
      .addCase(SET_PATH, (state, action: PayloadAction<string, typeof SET_PATH>) => ({ ...state, path: action.payload }));
  },
});

export default imageSlice.reducer;
